const variants = Array.from(document.querySelectorAll("[data-type='main-product-variant'] input"));
const mainImageLink = document.querySelector(".js-main-image");
const mainImage = mainImageLink.querySelector("img");
const variantActive = document.querySelector("[data-type='main-product-variant'] input:checked");

variants.forEach(function (variant) {
  variant.addEventListener("change", function () {
    pictureInfo(variant);
  });
});

function pictureInfo(variant) {
  let variantAttribute = variant.getAttribute('data-variants');
  let parentImage = document.querySelector(".js-thumb-img[data-variant = '" + variantAttribute + "']");
  if (parentImage) {
    let image = parentImage.querySelector('img');
    let imageLink = parentImage.getAttribute('href');
    let mainSmall = image.getAttribute('data-small');
    let mainMedium = image.getAttribute('data-medium');
    let mainBig = image.getAttribute('data-big');

    mainImageLink.setAttribute('href', imageLink);
    mainImage.setAttribute('src', imageLink);
    mainImage.setAttribute('srcset',
      mainSmall + " 320w, " +
      mainMedium + " 576w, " +
      mainBig + " 735w"
    );
  }
}

pictureInfo(variantActive);
